import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.9563 7.025C12.8063 7.175 12.625 7.247 12.4125 7.241C12.2 7.2345 12.0188 7.15625 11.8688 7.00625L9.75001 4.8875L9.75001 10.25C9.75001 10.4625 9.67801 10.6407 9.53401 10.7847C9.39051 10.9282 9.21251 11 9.00001 11C8.78751 11 8.60926 10.9282 8.46526 10.7847C8.32176 10.6407 8.25001 10.4625 8.25001 10.25L8.25001 4.8875L6.11251 7.025C5.96251 7.175 5.78426 7.25 5.57776 7.25C5.37176 7.25 5.19376 7.175 5.04376 7.025C4.89376 6.875 4.81876 6.69675 4.81876 6.49025C4.81876 6.28425 4.89376 6.10625 5.04376 5.95625L8.47501 2.525C8.55001 2.45 8.63126 2.39675 8.71876 2.36525C8.80626 2.33425 8.90001 2.31875 9.00001 2.31875C9.10001 2.31875 9.19376 2.33425 9.28126 2.36525C9.36876 2.39675 9.45001 2.45 9.52501 2.525L12.975 5.975C13.1125 6.1125 13.1813 6.28425 13.1813 6.49025C13.1813 6.69675 13.1063 6.875 12.9563 7.025Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.75 12.5C2.75 12.0858 3.08579 11.75 3.5 11.75C3.91421 11.75 4.25 12.0858 4.25 12.5C4.25 13.1904 4.80964 13.75 5.5 13.75H12.5C13.1904 13.75 13.75 13.1904 13.75 12.5C13.75 12.0858 14.0858 11.75 14.5 11.75C14.9142 11.75 15.25 12.0858 15.25 12.5C15.25 14.0188 14.0188 15.25 12.5 15.25H5.5C3.98122 15.25 2.75 14.0188 2.75 12.5Z",
		fill: "black"
	})]
});
export default SvgShare;
